import { ReactElement } from 'react'
import { CardProps } from './props'
import { StyledCard } from './styles'

const Card = ({ ...props }: CardProps): ReactElement => (
    <StyledCard {...props} />
)

export default Card

export { StyledCard }
